export default __webpack_public_path__ + "static/media/avatar-s-13.c5dbd907.jpg";